var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfdOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 93,
    viewBox: "0 0 112 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0277 29.2813C31.5809 21.5622 37.4763 14.9425 45.1954 14.4957L63.6333 13.4286C71.3524 12.9818 77.9721 18.8772 78.4189 26.5962L79.486 45.0343C79.9328 52.7533 74.0374 59.373 66.3184 59.8198L47.8804 60.887C40.1614 61.3337 33.5416 55.4384 33.0949 47.7193L32.0277 29.2813Z",
    fill: "url(#paint0_linear_8264_81718)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0277 29.2813C31.5809 21.5622 37.4763 14.9425 45.1954 14.4957L63.6333 13.4286C71.3524 12.9818 77.9721 18.8772 78.4189 26.5962L79.486 45.0343C79.9328 52.7533 74.0374 59.373 66.3184 59.8198L47.8804 60.887C40.1614 61.3337 33.5416 55.4384 33.0949 47.7193L32.0277 29.2813Z",
    fill: "url(#paint1_linear_8264_81718)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8264_81718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.172 42.3537L57.4787 30.3737C57.448 29.8442 57.1965 29.3492 56.7793 28.9976C56.3622 28.6461 55.8137 28.4668 55.2544 28.4991L46.8196 28.9873C46.2604 29.0197 45.7362 29.2611 45.3624 29.6584C44.9886 30.0558 44.7959 30.5765 44.8265 31.106L45.4621 42.0877C45.4774 42.3524 45.6032 42.5999 45.8118 42.7757C46.0203 42.9515 46.2946 43.0411 46.5742 43.025L48.6829 42.9029",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2323 42.2901L52.9062 42.6562",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4511 42.0454L65.5598 41.9233C65.8394 41.9071 66.1015 41.7864 66.2884 41.5878C66.4753 41.3891 66.5717 41.1287 66.5564 40.864L66.3455 37.2201C66.3319 36.9935 66.2374 36.7786 66.0775 36.6105L62.157 32.4802C62.0516 32.3689 61.921 32.2817 61.7749 32.225C61.6288 32.1683 61.4709 32.1435 61.3129 32.1524L57.6016 32.3672",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.457 44.1603C62.6216 44.0929 63.514 43.1443 63.4501 42.0416C63.3863 40.9389 62.3905 40.0996 61.2259 40.167C60.0613 40.2344 59.1689 41.183 59.2328 42.2857C59.2966 43.3884 60.2924 44.2277 61.457 44.1603Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9101 44.7775C52.0747 44.7101 52.9671 43.7615 52.9033 42.6588C52.8394 41.5561 51.8436 40.7168 50.679 40.7842C49.5144 40.8516 48.6221 41.8002 48.6859 42.9029C48.7497 44.0056 49.7455 44.8449 50.9101 44.7775Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_8264_81718",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.413 17.6698C65.2108 14.176 67.8792 11.1798 71.373 10.9776C74.8667 10.7754 77.863 13.4437 78.0652 16.9375C78.2674 20.4313 75.599 23.4275 72.1052 23.6297C68.6115 23.832 65.6152 21.1636 65.413 17.6698Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.413 17.6698C65.2108 14.176 67.8792 11.1798 71.373 10.9776C74.8667 10.7754 77.863 13.4437 78.0652 16.9375C78.2674 20.4313 75.599 23.4275 72.1052 23.6297C68.6115 23.832 65.6152 21.1636 65.413 17.6698Z",
    fill: "url(#paint2_linear_8264_81718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.413 17.6698M78.0652 16.9375M78.0652 16.9375M65.413 17.6698M71.373 10.9776M78.0652 16.9375M72.1052 23.6297M65.413 17.6698M72.1052 23.6297L71.9897 21.6331C69.5986 21.7715 67.5481 19.9453 67.4097 17.5543L65.413 17.6698L63.4164 17.7854C63.6824 22.3819 67.6243 25.8924 72.2208 25.6264L72.1052 23.6297ZM78.0652 16.9375L76.0685 17.0531C76.2069 19.4442 74.3808 21.4947 71.9897 21.6331L72.1052 23.6297L72.2208 25.6264C76.8173 25.3604 80.3279 21.4185 80.0618 16.822L78.0652 16.9375ZM71.373 10.9776L71.4885 12.9743C73.8796 12.8359 75.9301 14.662 76.0685 17.0531L78.0652 16.9375L80.0618 16.822C79.7958 12.2254 75.8539 8.71491 71.2574 8.98095L71.373 10.9776ZM71.373 10.9776L71.2574 8.98095C66.6609 9.24699 63.1503 13.1889 63.4164 17.7854L65.413 17.6698L67.4097 17.5543C67.2713 15.1632 69.0974 13.1127 71.4885 12.9743L71.373 10.9776Z",
    fill: "white",
    mask: "url(#path-8-inside-1_8264_81718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81718",
    x: -0.78125,
    y: -19.3828,
    width: 113.078,
    height: 113.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81718"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81718",
    x: 19.2188,
    y: 10.6172,
    width: 73.0781,
    height: 73.0781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81718",
    result: "effect2_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81718",
    x: 53.0469,
    y: 8.60938,
    width: 37.3828,
    height: 37.3828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81718",
    result: "effect2_dropShadow_8264_81718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81718",
    x1: 31.2188,
    y1: 15.3047,
    x2: 80.295,
    y2: 59.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81718",
    x1: 31.2188,
    y1: 15.3047,
    x2: 80.295,
    y2: 59.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81718",
    x1: 65.0469,
    y1: 11.3438,
    x2: 78.4313,
    y2: 23.2636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8264_81718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3467,
    height: 24,
    fill: "white",
    transform: "translate(42.375 25.2344) rotate(-3.31249)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfdOrders);
export default __webpack_public_path__ + "static/media/OFD Orders.c9f685f6778b8b1dd78ffdc30804eee2.svg";
export { ForwardRef as ReactComponent };